// extracted by mini-css-extract-plugin
module.exports = {"main":"drawerContent_main__1Cvl_","main_overflow":"drawerContent_main_overflow__2O2LT"};